import React from "react";
import TextLimiter from "../TextLimiter/TextLimiter";

const CellComponentDefault = ({ cell, row }) => {
  const value = row.original[cell.column.id];
  const valueType = typeof value;

  if (valueType === "number" || valueType === "string") {
    return <TextLimiter text={value} limit={100} />;
  } else if (valueType === "boolean") {
    return <TextLimiter text={value.toString()} limit={100} />;
  } else if (valueType === "object") {
    return <TextLimiter text={JSON.stringify(value)} limit={100} />;
  }
};

export const parseTableColumnsForCell = (columns) => {
  return columns?.map((column) => {
    switch (column.cell) {
      default:
        return {
          ...column,
          cell: column.cell ? column.cell : CellComponentDefault,
        };
    }
  });
};
